import { Service } from "@api/common";
import type { Base } from "./types";

class SupportService extends Service<Base> {
  constructor() {
    super("/support");
  }

  async createRequest(body: { gym: string; type: string; message: string }) {
    return this.post<{ threadId: string }>(`${this.basePath}`, body);
  }
}

export const supportService = new SupportService();
